module.exports = __webpack_public_path__ + "img/chelsea.a9bb0ea3.png";